import React from "react";

const Footer = () => {
  return (
    <section>
      <div className="text-center py-10 bg-gray-100">
        <p>Copyright © 2023 - All right reserved by ImproveYourSkill</p>
      </div>
    </section>
  );
};

export default Footer;
